// Angular
import { Component, Input, OnChanges } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { EVatDisplayMode } from 'libraries/service/vat/vat.interface';

export enum PriceType{
    big = 'big',
    default = 'default',
    large = 'large',
    light = 'light'
}

@Component({
    selector: 'price',
    template: `
        <span class="price"
            [ngClass]="type"
            [innerHTML]="value | price: currency"
            *ngIf="hasValue"></span>
        <span *ngIf="hasValue && vatDisplayMode">{{ vatWording[vatDisplayMode] }}</span>

        <span *ngIf="!hasValue && emptyLabel" class="label" [ngClass]="type">{{ emptyLabel }}</span>
    `,
    styles: [`
        .price, .label{
            font-weight: 600;
        }

        .price.big, .label.big {
            font-size: 1.5rem;
        }

        .price.large, .label.large {
            font-size: 1.5rem;
            font-weight: normal;
        }

        .price.light, .label.light {
            font-size: 1rem;
            font-weight: normal;
        }

        .price.default, .label.default {
            font-size: 1rem;
        }
    `]
})

export class PriceComponent implements OnChanges{
    @Input()
    public value: number;

    @Input()
    public type: PriceType = PriceType.default;

    @Input()
    public emptyLabel: string;

    @Input()
    public currency: string = 'EUR';

    @Input()
    public allowZeroValue: boolean = false;


    /**
     * * `null`|`undefined` : no VAT label displayed
     * * `includingVAT`|`excludingVAT` : matching label displayed
     */
    @Input()
    public vatDisplayMode?: EVatDisplayMode;

    public readonly vatWording: {[k in EVatDisplayMode]: string} = {
        excludingVAT: Yii.t('wui-shared-js', 'HT'),
        includingVAT: Yii.t('wui-shared-js', 'TTC'),
    };

    public hasValue: boolean = true;

    public ngOnChanges(): void{
        this.hasValue = this.checkValue();
    }

    private checkValue(): boolean{
        return Boolean(this.value) || (this.allowZeroValue && typeof this.value === "number");
    }

}
